export default "__VITE_ASSET__CICC$gBR__"